<div class="roi-seletion-panel-container custom-scrollbar bg-white p-2">
  <div class="flex-wrap align-items-start text-container">
    <span [style.font-size]="'14px'">{{ 'label.tags_selected' | translate | uppercase }}</span>
    <span [style.font-size]="'small'" [style.color]="'rgb(0, 153, 187)'">
      <a [style.cursor]="'pointer'" (click)="clearAll.emit()">{{ 'label.tags_clear' | translate }}</a>
    </span>
  </div>

  <div class="flex-row flex-wrap align-items-start labels-container custom-scrollbar">
    <ng-container *ngFor="let label of labels">
      <span class="roi-badge">
        <span class="roi-badge__label" [style.borderColor]="label.color" [style.color]="label.color"
          >{{ label.name }}
          <i class="ri-close-fill roi-badge__close-icon" (click)="clearLabel.emit(label.id)"></i>
        </span>
      </span>
    </ng-container>
  </div>
</div>
